import { Field } from '@dnb/eufemia/extensions/forms';
import type { ApiStage } from '@portals/shared/portal/ApiDto';
import classNames from 'classnames';
import React from 'react';

import styles from './index.module.css';

export const STAGE_OPTIONS: Record<ApiStage, string> = {
  upcoming: 'Upcoming',
  launched: 'Launched',
  deprecated: 'Deprecated',
  decommissioned: 'Decommissioned',
};

export const STAGE_ORDER: ApiStage[] = ['upcoming', 'launched', 'deprecated', 'decommissioned'];

type ApiStageTimeLineProps = {
  activeStage: ApiStage;
  interactive: boolean;
  isSaving?: boolean;
  onSelect?: (stage: ApiStage) => void;
};

const ApiStageTimeLine = ({ activeStage, interactive, isSaving = false, onSelect }: ApiStageTimeLineProps) => (
  <Field.Selection
    className={classNames(styles['TimelineSelection'])}
    disabled={isSaving}
    onChange={(value) => {
      if (interactive) {
        onSelect?.(value as ApiStage);
      }
    }}
    optionsLayout="horizontal"
    size="large"
    value={activeStage}
    variant="radio"
  >
    <div className={classNames(styles['TimelineSelectionContainer'])}>
      {!interactive && <div aria-hidden="true" className={styles['InteractionBlocker']} />}
      {STAGE_ORDER.map((stage, idx) => (
        <React.Fragment key={stage}>
          <div className={classNames(styles['StageWrapper'])}>
            <Field.Option key={stage} value={stage} />
            <label className={classNames(styles['StageName'], { [styles['ActiveName']!]: activeStage === stage })}>
              {STAGE_OPTIONS[stage]}
            </label>
          </div>

          {idx < STAGE_ORDER.length - 1 && (
            <div
              className={classNames(styles['StageLine'], {
                [styles['LineBlueGreen']!]: idx === 0,
                [styles['LineGreenYellow']!]: idx === 1,
                [styles['LineYellowRed']!]: idx === 2,
                [styles['StageLineSaving']!]: isSaving,
              })}
            />
          )}
        </React.Fragment>
      ))}
    </div>
  </Field.Selection>
);

export default ApiStageTimeLine;
